var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.visible ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('div', {
    staticClass: "overlay-content"
  }, [_vm._m(0), _c('h3', {
    staticClass: "text-white mt-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.text) + "...")])]), _vm._m(1)])]) : _vm._e();

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "spinner-border text-light",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h5', {
    staticClass: "text-white mt-1"
  }, [_c('strong', [_vm._v("Please wait a moment")])]);

}]

export { render, staticRenderFns }